import { render, staticRenderFns } from "./AutoReplyCommentsModal.vue?vue&type=template&id=aa6671e0"
import script from "./AutoReplyCommentsModal.vue?vue&type=script&lang=js"
export * from "./AutoReplyCommentsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa6671e0')) {
      api.createRecord('aa6671e0', component.options)
    } else {
      api.reload('aa6671e0', component.options)
    }
    module.hot.accept("./AutoReplyCommentsModal.vue?vue&type=template&id=aa6671e0", function () {
      api.rerender('aa6671e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/MetaUtils/Modals/AutoReplyCommentsModal.vue"
export default component.exports